import { Home } from '../../pages/Home/home';
import { Login } from '../../pages/Login/login';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { RootProvider } from '../providers/root-provider';
import { Analytics } from '../../pages/Analytics/analytics';
import { Team } from '../../pages/Team/team';
import { Settings } from '../../pages/Settings/settings';
import { Approvals } from '../../pages/Approvals/approvals'
import { ResetPassword } from '../../pages/Login/reset-password';

const router = createBrowserRouter([

    {
        path: '/login',
        element: <Login />,
    },
    {
        path: '/resetPassword',
        element: <ResetPassword />,
    },
    {
        // path: '/',
        element: <RootProvider />,
        errorElement: <Navigate to={'/login'} replace={true} />,
        children: [
            {
                path: '/home',
                element: <Home />,
            },
            {
                path: '/analytics',
                element: <Analytics />,
            },
            {
                path: '/team',
                element: <Team />,
            },
            {
                path: '/settings',
                element: <Settings />,
            },
            {
                path: '/approvals',
                element: <Approvals />,
            },
        ]
    },
    {
        path: '*',
        element: <Navigate to={'/login'} replace={true} />,
    },
], {
    basename: '/dashboard'
});
export default router;